import React from 'react'

function Shipping() {
  return (
    <h1>Shipping</h1>
  )
}

export default Shipping